import { useAuth } from "@/context/AuthContext";

export const ENTRY_MODULES = ["/admin/opportunities", "/admin/projects", "/admin/requests"];

export function usePerms() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const perms = { create: true, update: false, delete: false, ...(user?.permissions || {}) };
  const can = (action) => isAdmin || (user?.role === "editor" && !!perms[action]);
  return { isAdmin, can, user };
}
